import { ReactNode } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    minHeight: '100vh',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',

    [theme.media.mobile]: {
      minHeight: 'auto',
    },
  },
  illustration: {
    margin: theme.marginBase * 3,
    maxWidth: '100%',
  },
  h1: {
    ...theme.fonts.h2,
    margin: theme.marginBase * 3,
  },
  text: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    maxWidth: theme.maxContentWidth.reduced,
    marginBottom: theme.marginBase * 4,
  },
}));

interface Props {
  illustration?: string;
  title?: ReactNode;
  text?: ReactNode;
  button?: ReactNode;
  children?: ReactNode;
}

export const EmptyScreen = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <div className={classes.container}>
      {!!props.illustration && (
        <img
          src={props.illustration}
          alt="Illustration"
          className={classes.illustration}
        />
      )}
      {!!props.title && <h1 className={classes.h1}>{props.title}</h1>}
      {!!props.text && <p className={classes.text}>{props.text}</p>}

      {props.children}
      {props.button}
    </div>
  );
};
